import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '@zooplus/ui-components';

import {
  RetryPaymentIdealData,
  getRetryPaymentIdealData,
} from '../../../services/retryPaymentService';
import { useAppContext } from '../../AppContextProvider';

export type RetryPaymentIdealProps = {
  onError: (errorMessage: string) => void;
  orderId: string;
};

const RetryPaymentIdeal: React.FC<RetryPaymentIdealProps> = ({ onError, orderId }) => {
  const { t } = useTranslation();
  const [idealData, setIdealData] = useState<RetryPaymentIdealData>();
  const { domain, locale } = useAppContext();

  useEffect(() => {
    (async () => {
      try {
        const result = await getRetryPaymentIdealData({
          orderId,
          domain,
          locale,
        });
        setIdealData(result.data);
        console.log('Retry payment IDeal data', result.data);
      } catch (error: any) {
        onError(t('checkout.payment.creditcard.error.selectcard.apicall'));
      }
    })();
  }, [t, onError, orderId, domain, locale]);

  if (!idealData) {
    return null;
  }

  const { transactionId, transactionUrl } = idealData;

  if (transactionId) {
    return (
      <Alert variant="success">
        {t('order.ideal.paymentsuccessful', {
          '0': transactionId,
        })}
      </Alert>
    );
  }
  if (transactionUrl) {
    const handleClick = () => {
      window.location.replace(transactionUrl);
    };

    return (
      <Alert
        variant="warning"
        buttonText={t('order.ideal.payButtonText')}
        onButtonClick={handleClick}>
        {t('order.ideal.hint')}
      </Alert>
    );
  }
  return <Alert variant="warning">{t('order.ideal.error')}</Alert>;
};

export default RetryPaymentIdeal;
